import type { IPathBaseParam } from "./path";
import type { ICourseReviewStatsResponse } from "./types";

import type { IApiResponse } from "@/api";
import { createGetApi } from "@api/util/createGetApi";

const getApis = createGetApi<
  IApiResponse<ICourseReviewStatsResponse>,
  IPathBaseParam,
  object
>("courses.reviewStats.users.me");

export const me = {
  ...getApis,
};
